import { type ResultOf, type VariablesOf, graphql } from 'gql.tada';

const MapRestaurantsQuery = graphql(`
  query MapRestaurants($input: RestaurantInput, $siteId: Int) {
    allRestaurants(input: $input, siteId: $siteId) {
      __typename
      id
      lat
      lng
      rating
      offersFirstTable
      menuTitle
      heroImage
    }
  }
`);

export type QueryVariables = VariablesOf<typeof MapRestaurantsQuery>;
export type QueryResult = ResultOf<typeof MapRestaurantsQuery>;

export default MapRestaurantsQuery;
